import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

// Define a service using a base URL and expected endpoints
export const imageUpload = createApi({
  reducerPath: 'upload/image',
  tagTypes: ['upload'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    imageUpload: builder.mutation<any, FormData>({
      query(file) {
        return {
          url: '/upload/image',
          method: 'POST',
          data: file,
        };
      },
      invalidatesTags: [{ type: 'upload', id: 'UP' }],
      transformResponse: (result: { s3_image_url: string }) =>
        result.s3_image_url,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useImageUploadMutation } = imageUpload;
